import React from 'react';
import PropTypes from 'prop-types';

import { ATTACHMENTS } from 'newJs/config';
import { FaIcon, IoIcon } from 'components/Icons';
import { useAttachsParams } from 'providers/attachs-params';
import { useAttachsState } from 'providers/attachs-state';
import Action from 'containers/Attachments/Item/Action';
import AttachDataProvider from 'providers/attachs-data';

const {
    CLICK_ACTIONS: { DOWNLOAD_ALL, DOWNLOAD, SAVE_TO_FILES_ALL, VIEW_AS_GRID },
    VIEW_MODE
} = ATTACHMENTS;

const GroupedActions = (props) => {
    const {
        showDownload = true, showDownloadAll = false, showGridBtn = true, ...rest
    } = props;
    const { isApiEnabled } = useAttachsParams();
    const filesApiEnabled  = isApiEnabled('files');
    const { clickedItemData: itemData, currentViewMode } = useAttachsState();

    return (
        <AttachDataProvider value={itemData}>
            {showDownload
                ? showDownloadAll
                    ? (
                        <Action actionName={DOWNLOAD_ALL} {...rest}>
                            <IoIcon name='IoMdArchive' />
                        </Action>
                    ) : (
                        <Action actionName={DOWNLOAD} {...rest}>
                            <IoIcon name='IoMdDownload' />
                        </Action>
                    )
                : ''
            }
            {filesApiEnabled &&
                <Action actionName={SAVE_TO_FILES_ALL} {...rest}>
                    <i className='ico-product prod-files' />
                </Action>
            }
            {showGridBtn && (currentViewMode !== VIEW_MODE.GRID) &&
                <Action actionName={VIEW_AS_GRID} {...rest}>
                    <FaIcon name='FaTh' />
                </Action>
            }
        </AttachDataProvider>
    );
};

GroupedActions.propTypes = {
    showDownload: PropTypes.bool,
    showDownloadAll: PropTypes.bool,
    showGridBtn: PropTypes.bool
};

export default GroupedActions;
